module.exports = __webpack_public_path__ + "static/media/14_zemly_0_90.46.a31663d1.png";